"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var semantic_ui_react_1 = require("semantic-ui-react");
var useTranslationNs_1 = require("../../../hooks/useTranslationNs");
var FilterDropdown_1 = __importDefault(require("../FilterDropdown"));
var FilterSummary_1 = __importDefault(require("../FilterSummary"));
var TextInputFilter = function (_a) {
    var _b;
    var filter = _a.filter, toggleDropdown = _a.toggleDropdown, changeFilter = _a.changeFilter, appliedFilters = _a.appliedFilters;
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    var label = filter.label, name = filter.name;
    var _c = react_1.useState((_b = appliedFilters[name]) !== null && _b !== void 0 ? _b : ''), val = _c[0], setVal = _c[1];
    react_1.useEffect(function () {
        lodash_1.default.isUndefined(appliedFilters[name]) && setVal('');
    }, [appliedFilters[name]]);
    var handleChange = function (val) {
        setVal(val);
    };
    var formSelectedValue = function () {
        if (lodash_1.default.isString(val)) {
            return react_1.default.createElement("span", null, val);
        }
        return react_1.default.createElement("span", { className: "default-val" }, getTranslation('CHOOSE'));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterSummary_1.default, { handleClick: toggleDropdown, label: label.toLocaleUpperCase() }, formSelectedValue()),
        react_1.default.createElement(FilterDropdown_1.default, { handleClick: toggleDropdown, label: label.toUpperCase(), filterName: name },
            react_1.default.createElement(semantic_ui_react_1.Input, { placeholder: "", name: name, value: val, onChange: function (ev) { return handleChange(ev.target.value); }, onBlur: function (ev) {
                    var value = ev.target.value || undefined;
                    changeFilter(name, value, false, true);
                } }))));
};
exports.default = TextInputFilter;
